import { useCallback, useState } from "react"

export const getPopupAnchor =
    (anchor?: HTMLElement | null, isForm = false) =>
    (trigger: HTMLElement) => {
        const formFallback = document.querySelector(".ant-modal-content")

        if (!anchor && isForm && formFallback) return formFallback as HTMLElement
        if (!anchor) return trigger.parentElement ?? document.body
        return anchor
    }

// to resolve ANTD bug https://ant.design/docs/react/faq#Select-Dropdown-DatePicker-TimePicker-Popover-Popconfirm-scroll-with-the-page?
export const usePopUpAnchor = () => {
    const [popUpAnchor, setPopUpAnchor] = useState<HTMLElement>()
    const anchorRef = useCallback((node: HTMLElement | null) => {
        if (node !== null) {
            setPopUpAnchor(node)
        }
    }, [])

    return [popUpAnchor, anchorRef] as const
}
